/** File types the multi-select web input / camera batch accepts. */
export const ACCEPTED_IMAGE_TYPES = ['image/*'];

/** Marker used by the upload metadata for manually-captured documents. */
export const MANUAL_CAPTURE_FLAG = true;

/** Copy for the empty state shown before any page is captured. */
export const EMPTY_STATE_COPY = {
  title: 'Snap your documents',
  subtitle: 'Add a clear photo of each page — we read them and fill in the details.',
};

/** Primary affordance label by platform. */
export const ADD_SOURCE_LABEL = {
  web: 'Choose photos',
  native: 'Scan documents',
};

/** Label for the secondary "add more pages" affordance once a batch exists. */
export const ADD_MORE_LABEL = {
  web: 'Add more photos',
  native: 'Scan more',
};
